"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var Drawer_1;
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const two_js_1 = __importDefault(require("two.js"));
const axios_1 = __importDefault(require("axios"));
const Snail_1 = require("./models/Snail");
const Rows_1 = require("./models/Rows");
const BallScrew_1 = require("./models/BallScrew");
const vue_slideout_panel_vue_1 = __importDefault(require("../vue-slideout-panel.vue"));
const BallScrewElement_1 = require("./models/BallScrewElement");
let Drawer = Drawer_1 = class Drawer extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        // HTMLObject of current canvas
        this.elem = null;
        // Loaded record configurtion
        this.loadedConfiguration = {};
        // BallScrew object
        this.screwObj = null;
        //Configuration name
        this.confName = '';
        this.styles = {
            family: 'proxima-nova, sans-serif',
            size: 11,
            weight: 100,
            alignment: 'left'
        };
        this.styles1 = {
            family: 'proxima-nova, sans-serif',
            size: 11,
            weight: 100,
            alignment: 'center'
        };
        this.styles2 = {
            family: 'proxima-nova, sans-serif',
            size: 6,
            weight: 100,
            alignment: 'left'
        };
        this.styles3 = {
            family: 'proxima-nova, sans-serif',
            size: 9,
            weight: 100,
            alignment: 'left'
        };
    }
    // List of documentations
    get partNumber() {
        return this.loadedConfiguration.configuration.code;
    }
    // Created method
    created() {
    }
    // Mounted method
    mounted() {
        // Get canvas element
        this.elem = document.getElementById('canv');
        // Instance two.js library
        if (this.two == null) {
            this.two = new two_js_1.default({
                width: '100%',
                height: '100%'
            }).appendTo(this.elem);
        }
        axios_1.default.get('/api/drawer/get_configuration/' + this.idConfiguration).then(res => {
            this.loadedConfiguration = res.data;
            this.confName = this.loadedConfiguration.configuration.name;
            this.draw(res.data);
        }).catch(err => {
            console.log(err);
        });
    }
    draw(configuration) {
        BallScrewElement_1.BallScrewElement.COLORQUOTE = "#474749";
        let width = Drawer_1.A3Width;
        let height = Drawer_1.A3Height;
        this.drawPaper(width, height);
        let data = new Map();
        let ballScrew = this.loadedConfiguration.ballScrew;
        data.set(["DIAMETRO NOMINALE", "NOMINAL DIAMETER"], ballScrew.nominal_diameter);
        data.set(["PASSO", "LEAD"], ballScrew.lead);
        data.set(["VERSO FILETTATURA", "THREAD DIRECTION"], "DESTRO / RIGHT");
        data.set(["TIPO CHIOCCHIOLA", "BALL NUT TYPE"], ballScrew.preload.toLowerCase() == "s" ? 'PRELOADED' : 'NOT PRELOADED');
        data.set(["CODICE CHIOCCIOLA", "BALL NUT CODE"], ballScrew.code);
        data.set(["GUARNIZIONI", "SEALS"], this.loadedConfiguration.configuration.protection.code_letter == "0" ? "No" : "Yes");
        data.set(["TERMINALE DESTRO", "RIGHT SHAFT END"], this.loadedConfiguration.configuration.terminal_right_code);
        data.set(["TERMINALE SINISTRO", "LEFT SHAFT END"], this.loadedConfiguration.configuration.terminal_left_code);
        data.set(["CARICO DINAMICO Ca", "DYNAMIC LOAD Ca"], ballScrew.dynamic_load);
        data.set(["CARICO STATICO Co", "STATIC LOAD Co"], ballScrew.static_load);
        data.set(["RIGIDITÀ Rb/t", "RIGIDITY Rb/t"], ballScrew.stiffness || "-");
        if (ballScrew.preload.toLowerCase() === "n") {
            data.set(["COPPIA DI PRECARICO - GUARNIZIONI", "PRELOAD TORQUE WITHOUT SEALS"], "-");
            data.set(["COPPIA DI PRECARICO + GUARNIZIONI", "PRELOAD TORQUE WITH SEALS"], "-");
            data.set(["GIOCO ASSIALE", "BACKLASH"], ballScrew.backlash.max_backlash + " MAX");
        }
        else {
            data.set(["COPPIA DI PRECARICO - GUARNIZIONI", "PRELOAD TORQUE WITHOUT SEALS"], this.loadedConfiguration.configuration.preload_torque_range);
            data.set(["COPPIA DI PRECARICO + GUARNIZIONI", "PRELOAD TORQUE WITH SEALS"], this.loadedConfiguration.configuration.preload_torque_max + " MAX");
        }
        data.set(["LUBRIFICARE CON", "LUBRICATION WITH"], this.loadedConfiguration.configuration.lubrication.id == 1 ? "Grasso / Grease" : "Olio / Oil");
        const table = this.drawTable(400, 30, data);
        table.translation.set(15, height - (data.size * 30));
        this.two.add(table);
        // Calculate 2/3 of the screen as correct snail width
        let numTerminal = 0;
        if (configuration.left_terminal != null && configuration.left_terminal.terminalcode != "T0") {
            numTerminal++;
        }
        if (configuration.right_terminal != null && configuration.right_terminal.terminalcode != "T0") {
            numTerminal++;
        }
        const screwAll = new two_js_1.default.Group();
        this.two.add(screwAll);
        // Create screw
        this.screwObj = new BallScrew_1.BallScrew(String(BallScrew_1.BallScrew.DrawerStyle.DOCUMENT));
        const correctWidth = this.elem.offsetWidth / 5;
        const screw = this.screwObj.draw(this.two, this.elem, configuration.ballScrew, configuration, correctWidth, 1100);
        const tW = this.screwObj.getTerminalWidth(this.screwObj.getData().left_terminal_record);
        const leftX = 750 - this.screwObj.getData().screwWidth / 2 - tW - 90;
        screw.translation.set(-leftX, -240);
        screwAll.add(screw);
        //Add right bottom table
        let table1Width = 540;
        let table1 = new two_js_1.default.Rectangle(width - (table1Width / 2) - 15, height - 135, table1Width, 240);
        table1.linewidth = 0.7;
        table1.noFill();
        let lineHead = Rows_1.Rows.draw(this.two, width - table1Width - 15, height - 230, width - 15, height - 230, Rows_1.RowsStyle.Thread);
        this.two.add(lineHead);
        this.two.makeText("GENERAL TOLERANCES: ISO 2768-mK", width - table1Width, height - 241, this.styles);
        this.two.add(table1);
        let lineHead1 = Rows_1.Rows.draw(this.two, width - table1Width - 15, height - 113, width - 15, height - 113, Rows_1.RowsStyle.Thread);
        this.two.add(lineHead1);
        this.two.makeText("CONFIGURATED BALL SCREW ASSY", width - table1Width - 4, height - 95, this.styles);
        let sperator = Rows_1.Rows.draw(this.two, width - (table1Width / 2) - 20, height - 113, width - (table1Width / 2) - 20, height - 80, Rows_1.RowsStyle.Thread);
        this.two.add(sperator);
        this.two.makeText("SCALE: Drawing not to scale", width - (table1Width / 2) - 5, height - 95, this.styles);
        let lineHead2 = Rows_1.Rows.draw(this.two, width - table1Width - 15, height - 80, width - 15, height - 80, Rows_1.RowsStyle.Thread);
        this.two.add(lineHead2);
        this.two.makeText("PART NO." + this.partNumber, width - table1Width - 4, height - 60, this.styles);
        let lineHead3 = Rows_1.Rows.draw(this.two, width - table1Width - 15, height - 47, width - 15, height - 47, Rows_1.RowsStyle.Thread);
        this.two.add(lineHead3);
        this.two.makeText("THIS DRAWING IS PRIVATE AND CONFIDENTIAL AND IS SUPPLIEDE", width - table1Width - 6, height - 40, this.styles2);
        this.two.makeText("ON THE CONDITION THAT IT IS NOT TO BE USED FOR ANY PURPOSE", width - table1Width - 6, height - 33, this.styles2);
        this.two.makeText("OR COPIED OR COMMUNICATED TO ANY OTHER PERSON WITHOUT THE", width - table1Width - 6, height - 26, this.styles2);
        this.two.makeText("WRITTEN PERMISSION OF UMBRAGROUP SpA", width - table1Width - 4, height - 19, this.styles2);
        // Add svg
        this.two.load("/images/notice.svg", (svg) => {
            this.two.add(svg);
            svg.translation.set(width - table1Width + 210, height - 45); // move to the center of the canvas
            this.two.update();
        });
        let sperator1 = Rows_1.Rows.draw(this.two, width - table1Width + 205, height - 15, width - table1Width + 205, height - 48, Rows_1.RowsStyle.Thread);
        this.two.add(sperator1);
        let sperator2 = Rows_1.Rows.draw(this.two, width - table1Width + 275, height - 15, width - table1Width + 275, height - 48, Rows_1.RowsStyle.Thread);
        this.two.add(sperator2);
        this.two.makeText("NAME: " + this.stringTruncate(this.loadedConfiguration.configuration.name, 45), width - table1Width + 280, height - 35, this.styles3);
        this.two.makeText("CUSTOMER: " + this.stringTruncate(this.loadedConfiguration.configuration.user.business_name, 40), width - table1Width + 280, height - 22, this.styles3);
        // Add snail
        const snailRadius = ballScrew.D6 * this.screwObj.getScaleFactor();
        let snail = null;
        const flangetype = configuration.configuration.flange.substr(0, 1);
        let style = null;
        switch (flangetype) {
            case "a":
                style = Snail_1.SnailStyle.Circle;
                break;
            case "b":
                style = Snail_1.SnailStyle.BothFlat;
                break;
            case "c":
                style = Snail_1.SnailStyle.TopFlat;
                break;
        }
        let snailObj = new Snail_1.Snail(this.two);
        this.screwObj.addElementsToQuote(snailObj);
        snail = snailObj.drawFront(this.two, ballScrew, this.screwObj.getScaleFactor(), style, ballScrew.nominal_diameter >= 40 ? 8 : 6, true);
        snail.translation.set(this.elem.offsetWidth - snailRadius - 150, height / 2 - snailRadius / 2 - 239);
        screwAll.add(snail);
        // // Add svg
        this.two.load("/images/logo.svg", (svg) => {
            this.two.add(svg);
            svg.translation.set(width - table1Width - 10, height - 230); // move to the center of the canvas
            this.two.update();
        });
        // Add svg
        this.two.load("/images/triangle.svg", (svg) => {
            this.two.add(svg);
            svg.translation.set(480, height / 2 + 80); // move to the center of the canvas
            this.two.update();
        });
        // 1
        this.two.makeText("1", 499, height / 2 + 100);
        this.two.makeText("MARCATURA LASER SECONDO SI 13 025", 525, height / 2 + 95, this.styles);
        this.two.makeText("LASER MARKING ACCORDING TO SI 13 025", 525, height / 2 + 105, this.styles);
        // 2
        this.two.makeText("2", 499, height / 2 + 165);
        this.two.makeText("GEOMETRIA DELLA FILETTATURA SEC. UG-BTG-0001", 525, height / 2 + 160, this.styles);
        this.two.makeText("BALL TRACK GEOMETRY ACCORDING TO UG-BTG-0001", 525, height / 2 + 170, this.styles);
        // 3
        this.two.makeText("3", 499, height / 2 + 230);
        this.two.makeText("ALBERO VITE: 42CD4 O MATERIALE EQUIVALENTE", 525, height / 2 + 225, this.styles);
        this.two.makeText("CHIOCCIOLA:100Cr6 O MATERIALE EQUIVALENTE", 525, height / 2 + 235, this.styles);
        this.two.makeText("SCREW SHAFT:42CD4 OR EQUIVALENT MATERIAL", 525, height / 2 + 250, this.styles);
        this.two.makeText("BALL NUT:100Cr6 OR EQUIVALENT MATERIAL", 525, height / 2 + 260, this.styles);
        // 4
        this.two.makeText("4", 499, height / 2 + 320);
        this.two.makeText("TOLLERANZE GEOMETRICHE E PRECISIONE", 525, height / 2 + 315, this.styles);
        this.two.makeText("SECONDO ISO 3408 -3", 525, height / 2 + 325, this.styles);
        this.two.makeText("PRECISION AND GEOMETRY TOLERANCES", 525, height / 2 + 340, this.styles);
        this.two.makeText("ACCORDING TO ISO 3408-03", 525, height / 2 + 350, this.styles);
        this.screwObj.showAllQuotes();
        this.two.update();
        this.screwObj = null;
        data = null;
        ballScrew = null;
    }
    /**
     * Truncate a string
     * @param str
     * @param length
     */
    stringTruncate(str, length) {
        if (str === null)
            return "";
        var dots = str.length > length ? '...' : '';
        return str.substring(0, length) + dots;
    }
    ;
    drawTable(width, rowHeight, data) {
        // Add left bottom table
        let tableGroup = new two_js_1.default.Group();
        let row = 0;
        data.forEach((value, key) => {
            const line = this.two.makeRectangle(width / 2, (rowHeight * row), width, rowHeight);
            line.linewidth = 0.5;
            tableGroup.add(line);
            tableGroup.add(this.two.makeText(key[0], 10, (rowHeight * row) - 5, this.styles));
            tableGroup.add(this.two.makeText(key[1], 10, (rowHeight * row) + 7, this.styles));
            let diff = (width - (width / 3) * 2) / 2;
            if (row == 1 || row == 2) {
                tableGroup.add(this.two.makeText("mm", (width / 3) * 2 - 24, (rowHeight * row), this.styles));
            }
            else if (row == 8 || row == 9) {
                tableGroup.add(this.two.makeText("KN", (width / 3) * 2 - 24, (rowHeight * row), this.styles));
            }
            else if (row == 10) {
                tableGroup.add(this.two.makeText("N/micr.", (width / 3) * 2 - 40, (rowHeight * row), this.styles));
            }
            else if (row == 11 || row == 12) {
                tableGroup.add(this.two.makeText("daNcm", (width / 3) * 2 - 40, (rowHeight * row), this.styles));
            }
            tableGroup.add(this.two.makeText(value, (width / 3) * 2 + diff, (rowHeight * row), this.styles1));
            row++;
        });
        const vline = this.two.makeLine((width / 3) * 2, -rowHeight / 2, (width / 3) * 2, (rowHeight * (row - 1)) + rowHeight / 2);
        vline.linewidth = 0.5;
        tableGroup.add(vline);
        return tableGroup;
    }
    drawPaper(width, height) {
        // Draw skeleton
        let gridWidth = 15;
        const externalRect = new two_js_1.default.Rectangle(width / 2, height / 2, width, height);
        externalRect.linewidth = 0.5;
        this.two.add(externalRect);
        this.two.add(new two_js_1.default.Rectangle(width / 2, height / 2, width - gridWidth * 2, height - gridWidth * 2));
        let squareVertical = height / 4;
        for (var i = 1; i <= 3; i++) {
            this.two.add(new two_js_1.default.Line(0, squareVertical * i, gridWidth, squareVertical * i));
            this.two.add(new two_js_1.default.Line(width - gridWidth, squareVertical * i, width, squareVertical * i));
        }
        let squareHorizontal = width / 6;
        for (var i = 1; i <= 5; i++) {
            this.two.add(new two_js_1.default.Line(squareHorizontal * i, height - gridWidth, squareHorizontal * i, height));
            this.two.add(new two_js_1.default.Line(squareHorizontal * i, 0, squareHorizontal * i, gridWidth));
        }
        let letters = ["D", "C", "B", "A"];
        for (var i = 1; i <= 4; i++) {
            this.two.makeText(letters[i - 1], gridWidth / 2, squareVertical * i - (squareVertical / 2), this.styles1);
            this.two.makeText(letters[i - 1], width - gridWidth / 2, squareVertical * i - (squareVertical / 2), this.styles1);
        }
        for (var i = 0; i <= 6; i++) {
            this.two.makeText((6 - i).toString(), squareHorizontal * i + (squareHorizontal / 2), gridWidth / 2 + 3, this.styles1);
            this.two.makeText((6 - i).toString(), squareHorizontal * i + (squareHorizontal / 2), height - (gridWidth / 2) + 3, this.styles1);
        }
    }
    downloadDraw() {
        axios_1.default.post('/drawer/savepdf', {
            data: this.elem.innerHTML
        })
            .then((response) => {
            var win = window.open('/drawer/downloadpdf', '_blank');
            win.focus();
        }).catch(err => {
            console.log(err);
        });
    }
    downloadDatasheet() {
        var win = window.open('/drawer/downloaddatasheet/' + this.loadedConfiguration.configuration.id, '_blank');
        win.focus();
    }
};
Drawer.A3Width = 1500;
Drawer.A3Height = 1040;
__decorate([
    vue_property_decorator_1.Prop({ default: 0 })
], Drawer.prototype, "idConfiguration", void 0);
Drawer = Drawer_1 = __decorate([
    vue_property_decorator_1.Component({
        components: {
            'vue-slideout-panel': vue_slideout_panel_vue_1.default
        }
    })
], Drawer);
exports.default = Drawer;
